import {createAsyncThunk} from '@reduxjs/toolkit';

import {generateRandomString} from 'shared/utils/random';

import {apiRequestProgressSliceActions} from './api-request-progress-slice';
import {API_REQUEST_PROGRESS_SLICE} from './api-request-progress-slice-constants';
import {IApiRequestProgressEntity} from './api-request-progress-slice-types';

export const createRequestProgress = createAsyncThunk<
    string, Omit<IApiRequestProgressEntity, 'id'> & {
        id?: string;
    } | void
>(
    `${API_REQUEST_PROGRESS_SLICE}/createRequestProgress`,
    (args, {dispatch}) => {
        const id = generateRandomString();

        dispatch(apiRequestProgressSliceActions.addRequestProgress({
            id,
            ...(args ?? undefined),
        }));

        return id;
    },
);
